import React from "react";

interface FormFieldProps {
  label: string;
  /** Rendered as the input's `id`, so the label is click-to-focus. */
  htmlFor?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Reusable Form Field
 * Bold label above the control with an error line beneath it — the layout used
 * across admin form pages.
 */
const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  error,
  required = false,
  children,
  className = "",
}) => (
  <div className={className}>
    <label
      htmlFor={htmlFor}
      className="block text-sm font-semibold text-grease-100 mb-2"
    >
      {label}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-xs text-red-500 mt-1.5">{error}</p>}
  </div>
);

export default FormField;
